<h1 mat-dialog-title>{{ 'isothermalCharacterizationEdit.dialog.confirmSave.title' | translate }}</h1>
<form [formGroup]="form">
  <div mat-dialog-content class="calibrates-theme">

    @if (data.showReason) {
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'isothermalCharacterizationEdit.dialog.confirmSave.reason.label' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="data.reason" formControlName="reason" [errorStateMatcher]="matcher" required></textarea>
        <mat-error>
          {{ 'isothermalCharacterizationEdit.dialog.confirmSave.reason.error' | translate }}
        </mat-error>
      </mat-form-field>
    }

  </div>
  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>

    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>

    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>